import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { RemoveClientReportForm } from 'modules/components/layer12';

export type RemoveClientReportModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveClientReportModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove client report'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveClientReportForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
